var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.84,
    height: 14.84,
    viewBox: "0 0 14.84 14.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49398",
    "data-name": "Group 49398",
    transform: "translate(-3172.75 8311.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 6.67,
    cy: 6.67,
    r: 6.67,
    transform: "translate(3173.5 -8311)",
    fill: "none",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93671",
    "data-name": "Path 93671",
    d: "M72,17.492v4.22l2.8,2.8",
    transform: "translate(3107.666 -8325.491)",
    fill: "none",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.a72e6aef48586bc54bfd1476684f7ad3.svg";
export { ForwardRef as ReactComponent };